<script>
import ActionConfirmationModal from './ActionConfirmationModal.vue'
import Money from '@src/mixins/money'

export default {
  mixins: [Money],
  emits: ['confirm', 'hidden'],
  components: {
    ActionConfirmationModal,
  },
  props: {
    charge: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    sale: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    clientName() {
      return this.sale.client && this.sale.client.name
        ? this.sale.client.name
        : '-'
    },
    chargeIdentifier() {
      return this.charge.transaction_id || `#${this.charge.id || '-'}`
    },
    action() {
      return {
        title: 'Reembolsar Parcela',
        initialDescription:
          'Tem certeza que deseja reembolsar esta parcela da assinatura?',
        confirmationDescription:
          'Digite a frase abaixo para confirmar o reembolso da parcela.',
        confirmationPhrase: 'REEMBOLSAR PARCELA',
        nextLabel: 'Avançar e Reembolsar',
        confirmLabel: 'Confirmar Reembolso',
        alert: {
          title: 'Ação Irreversível',
          description:
            'Esta ação não pode ser desfeita. O valor desta parcela será estornado ao cliente e a cobrança será marcada como reembolsada.',
        },
      }
    },
    confirmationFields() {
      return [
        { label: 'Cliente', value: this.clientName },
        { label: 'ID da Parcela', value: this.chargeIdentifier },
        {
          label: 'Valor',
          value: `R$ ${this.formatMoney(this.charge.amount || 0)}`,
        },
      ]
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('confirm', this.charge)
    },
  },
}
</script>

<template>
  <ActionConfirmationModal
    id="refund-installment-modal"
    :action="action"
    :confirmation-fields="confirmationFields"
    :loading="loading"
    :error-message="errorMessage"
    @confirm="handleSubmit"
    @hidden="$emit('hidden')"
  />
</template>
